import React, { useState, useRef, useLayoutEffect } from 'react';

import {
	CancellationReasonPanel,
	CancellationReasonHeader,
	CancellationReasonMeta,
	CancellationReasonTag,
	CancellationReasonText,
	ShowMoreButton,
} from './Styles/OrderDetails';

import { formatCancelledAt } from './Utils';

const CancellationReasonBox = ({ item }) => {
	const [expanded, setExpanded] = useState(false);
	const [overflowing, setOverflowing] = useState(false);
	const textRef = useRef(null);

	useLayoutEffect(() => {
		if (textRef.current)
			setOverflowing(textRef.current.scrollHeight > textRef.current.clientHeight + 2);
	}, [item.comment]);

	return (
		<CancellationReasonPanel>
			<CancellationReasonHeader>
				Cancellation Reason
				{item.cancelled_by || item.cancelled_at ? (
					<CancellationReasonMeta>
						{`· Cancelled by ${item.cancelled_by || 'seller'}${item.cancelled_at ? ` on ${formatCancelledAt(item.cancelled_at)}` : ''}`}
					</CancellationReasonMeta>
				) : null}
				{item.order_cancel ? <CancellationReasonTag>Order cancel</CancellationReasonTag> : null}
			</CancellationReasonHeader>

			<CancellationReasonText
				ref={textRef}
				expanded={expanded}
			>
				{item.comment}
			</CancellationReasonText>

			{overflowing ? (
				<ShowMoreButton onClick={() => setExpanded(!expanded)}>
					{expanded ? 'Show less' : 'Show more'}
				</ShowMoreButton>
			) : null}
		</CancellationReasonPanel>
	);
};

export default CancellationReasonBox;
